import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { canAccessPath } from "../utils/permissions";

export const publicPaths = ["/login", "/signup"];

const ProtectedRoute = () => {
  const { user, loading } = useAuth();
  const location = useLocation();
  const currentPath = location.pathname;

  if (loading) {
    return <div>Loading...</div>;
  }

  const isPublicRoute = publicPaths.some(
    (path) => currentPath === path || currentPath.startsWith(`${path}/`)
  );

  if (isPublicRoute) {
    return user ? <Navigate to="/" replace /> : <Outlet />;
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (!canAccessPath(user, currentPath)) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
